import _defineProperty from "/home/circleci/neene-player/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/defineProperty";
import { unit } from '@ant-design/cssinjs';
var genSelectionStyle = function genSelectionStyle(token) {
  var componentCls = token.componentCls,
    antCls = token.antCls,
    iconCls = token.iconCls,
    fontSizeIcon = token.fontSizeIcon,
    padding = token.padding,
    paddingXS = token.paddingXS,
    headerIconColor = token.headerIconColor,
    headerIconHoverColor = token.headerIconHoverColor,
    tableSelectionColumnWidth = token.tableSelectionColumnWidth,
    tableSelectedRowBg = token.tableSelectedRowBg,
    tableSelectedRowHoverBg = token.tableSelectedRowHoverBg,
    tableRowHoverBg = token.tableRowHoverBg,
    tablePaddingHorizontal = token.tablePaddingHorizontal,
    calc = token.calc;
  return _defineProperty({}, "".concat(componentCls, "-wrapper"), _defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty(_defineProperty({}, "".concat(componentCls, "-selection-col"), _defineProperty({
    width: tableSelectionColumnWidth
  }, "&".concat(componentCls, "-selection-col-with-dropdown"), {
    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).equal()
  })), "".concat(componentCls, "-bordered ").concat(componentCls, "-selection-col"), _defineProperty({
    width: calc(tableSelectionColumnWidth).add(calc(paddingXS).mul(2)).equal()
  }, "&".concat(componentCls, "-selection-col-with-dropdown"), {
    width: calc(tableSelectionColumnWidth).add(fontSizeIcon).add(calc(padding).div(4)).add(calc(paddingXS).mul(2)).equal()
  })), "\n        table tr th".concat(componentCls, "-selection-column,\n        table tr td").concat(componentCls, "-selection-column,\n        ").concat(componentCls, "-selection-column\n      "), _defineProperty({
    paddingInlineEnd: token.paddingXS,
    paddingInlineStart: token.paddingXS,
    textAlign: 'center'
  }, "".concat(antCls, "-radio-wrapper"), {
    marginInlineEnd: 0
  })), "table tr th".concat(componentCls, "-selection-column").concat(componentCls, "-cell-fix-left"), {
    zIndex: calc(token.zIndexTableFixed).add(1).equal({
      unit: false
    })
  }), "table tr th".concat(componentCls, "-selection-column::after"), {
    backgroundColor: 'transparent !important'
  }), "".concat(componentCls, "-selection"), {
    position: 'relative',
    display: 'inline-flex',
    flexDirection: 'column'
  }), "".concat(componentCls, "-selection-extra"), _defineProperty({
    position: 'absolute',
    top: 0,
    zIndex: 1,
    cursor: 'pointer',
    transition: "all ".concat(token.motionDurationSlow),
    marginInlineStart: '100%',
    paddingInlineStart: unit(calc(tablePaddingHorizontal).div(4).equal())
  }, iconCls, {
    color: headerIconColor,
    fontSize: fontSizeIcon,
    verticalAlign: 'baseline',
    '&:hover': {
      color: headerIconHoverColor
    }
  })), "".concat(componentCls, "-tbody"), _defineProperty({}, "".concat(componentCls, "-row"), _defineProperty(_defineProperty({}, "&".concat(componentCls, "-row-selected"), _defineProperty({}, "> ".concat(componentCls, "-cell"), {
    background: tableSelectedRowBg,
    '&-row-hover': {
      background: tableSelectedRowHoverBg
    }
  })), "> ".concat(componentCls, "-cell-row-hover"), {
    background: tableRowHoverBg
  }))));
};
export default genSelectionStyle;